/**
 * Chemins des ecrans d'exploitation (sante du service, traitements en erreur).
 *
 * Module **pur**, comme `admin/users/routes.ts` : le menu (`ui/navigation.ts`) et
 * `App.tsx` l'importent tous deux, et un chemin ecrit en clair aux deux endroits
 * se maintiendrait deux fois.
 */

export const HEALTH_PATH = '/operations/health';

export const FAILED_MESSAGES_PATH = '/operations/failed-messages';
